import { inject, Injectable } from '@angular/core';
import { FacebookAuthResponse, FacebookLogin, FacebookLoginResponse } from '@luggagehero/shared/interfaces';

import { FacebookSdk } from './facebook.sdk';

@Injectable()
export class FacebookLoginService implements FacebookLogin {
  private facebookSdk = inject(FacebookSdk);

  /** Start loading the SDK before a Facebook button can be tapped (AM-5110). */
  preload(): void {
    this.facebookSdk.preload();
  }

  async login(): Promise<FacebookAuthResponse> {
    const fb = await this.facebookSdk.load();

    return new Promise<FacebookAuthResponse>((resolve) => {
      const options = { scope: 'email', return_scopes: true };

      fb.login((res: FacebookLoginResponse) => {
        resolve(res.status === 'connected' ? res.authResponse : null);
      }, options);
    });
  }

  async logout() {
    try {
      const fb = await this.facebookSdk.load();
      await new Promise<void>((resolve) => fb.logout(() => resolve()));
    } catch {
      // Ignore
    }
  }
}
